import { render } from "./header.vue?vue&type=template&id=6bb30e6c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=6bb30e6c&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=6bb30e6c&lang=scss"

import exportComponent from "E:\\liuniuWork\\example\\IPv6\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb30e6c"]])

export default __exports__